import BaseController from "controllers/base"
import { placesUri } from "servos/googlePlaces"
import GeocompletedAddress, { syncCustomAddressFields } from "widgets/geocompletedAddress"

class Controller extends BaseController {
  call() {
    const elem = this.root.find("#tenant-location-fields-group")
    if (!elem.length) {
      return
    }

    new GeocompletedAddress({
      root: elem,
      options: {
        types: ["address"],
        country: "AU"
      }
    })

    syncCustomAddressFields(elem)

    this.root.find('.file-upload-input').on('change', function() {
      const filename = this.files[0] ? this.files[0].name : ''
      $(this).closest('.file-upload-label').find('.file-upload-filename').text(filename)
    })
  }

  scripts() {
    return [placesUri]
  }
}

export default Controller
